<template>
  <div class="add-review">
    <v-container>
      <h2 class="grey--text">Rango de precios</h2>
      <v-card class="mx-auto mt-4 pa-4" outlined>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field label="Precio inicial" v-model="form.startPrice" :rules="rules.startPrice" required></v-text-field>
              </v-col>       
              <v-col cols="6" sm="6" md="6">
                <v-text-field label="Precio final" v-model="form.endPrice" :rules="rules.endPrice" required></v-text-field>
              </v-col>       
            </v-row>
          </v-container>
        </v-form>
      </v-card>
      <v-spacer></v-spacer>
      <v-btn
        class="my-4 float-right"
        color="primary"
        @click="validate"
        :loading="loading"
        depressed
      >Guardar</v-btn>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    id: "",
    loading: false,
    form: {
      startPrice: null,
      endPrice: null
    },
    valid: false,
    rules: {
      startPrice: [v => !!v || "Campo requerido", v => /^\d+$/.test(v) || "Capturar solamente números"],
      endPrice: [v => !!v || "Campo requerido", v => /^\d+$/.test(v) || "Capturar solamente números"]
    }
  }),
  methods: {
     async validate() {
      await this.$refs.form.validate();

      if (!this.valid) {
        return;
      } else {
        this.loading = true;
        
        this.$http.post("configuration", {_id: this.id, key: "rangePrices", value: this.form}).then((res) => {
          this.loading  = false;
          this.id       = res.data._id;
          this.showAlert('Rango de precio guardado con éxito');
        }).catch((error) => {
          this.loading = false;
          this.showAlert('Problema para guardar el rango de precio, intentar de nuevo', 'danger');
        });
      }
    },
    showAlert(message, type = "success"){
        this.$store.commit("SNACKBAR", { text: message, isShow: true, type: type });
    },
    getRangePrices(){
        this.loading = true;
        this.$http.get("configuration/rangePrices").then((res) => {
            if(res.data && res.data.length > 0){
                this.form   = res.data[0].value;
                this.id     = res.data[0]._id;
            }
            this.loading = false;
        }).catch((error) => {
            this.loading = false;
        });
    }
  },
  mounted(){
    this.getRangePrices();
  }
};
</script>

<style scoped>
label {
  padding: 40px;
  /* background: green; */
  height: 100%;
  width: 100%;
  border-radius: 4px;
  /* color: #fff; */
  text-align: center;
  font-weight: 500;
  font-size: 1.1rem;
  display: block;
  cursor: pointer;
}

.v-btn--example {
  bottom: 0;
  position: absolute;
  margin: 0px -24px 0px 0px;
}
</style>
